import { DB_INSTANCE_API } from "../../config";
import { POST } from "../../helper/xbi4RestFunctions";

export const turnOnDbInstance = async () => {
  const path = `https://zg679v6gv9.execute-api.ap-south-1.amazonaws.com/collatica-database-on-off?action=start`;
  return await fetch(path, {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify({}),
  })
    .then((result) => {
      console.log("Database instance turn-on result:", result);
      return result;
    })
    .catch((err) => {
      console.log("Error turning on database instance:", err);
      return err;
    });
};

export const turnOffDbInstance = async () => {
  const path = `https://zg679v6gv9.execute-api.ap-south-1.amazonaws.com/collatica-database-on-off?action=stop`;
  return await fetch(path, {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify({}),
  })
    .then((result) => {
      console.log("Database instance turn-off result:", result);
      return result;
    })
    .catch((err) => {
      console.log("Error turning off database instance:", err);
      return err;
    });
}; 